import { PurchaseEvent } from 'shared'
import { create } from 'zustand'

export interface TaxationStoreState {
  purchaseEvents: PurchaseEvent[]
  setPurchaseEvents: (v: PurchaseEvent[]) => void

  startingIndexTour: number
  setStartingIndexTour: (newIndex: number) => void
}

export const useTaxationStore = create<TaxationStoreState>()((set) => ({
  purchaseEvents: [],
  setPurchaseEvents: (newPurchaseEvents: PurchaseEvent[]) =>
    set({ purchaseEvents: newPurchaseEvents }),

  startingIndexTour: 0,
  setStartingIndexTour: (newIndex: number) => set({ startingIndexTour: newIndex }),
}))
